export default __webpack_public_path__ + "static/media/paymentUpload.9e1a7364.svg";